<template>
    <div class="side-bar" :class="{ active: show }">
        <button class="side-bar-close" @click="closeSideBar">
            <i class="fal fa-times"></i>
        </button>
        <div class="side-bar-logo">
            <a :href="homeURL">
                <img src="~@/assets/images/logo.svg" alt="Logo" />
            </a>
        </div>
        <div class="side-bar-menu" :class="{ active: sidebarActive }">
            <ul class="main-menu pb-5">
                <li v-for="(item, index) in menu" :key="index">
                    <router-link
                        :to="{ name: item.link.name }"
                        :class="{
                            active: isActive(item.link.name),
                        }"
                        @click.native="closeSideBar"
                    >
                        <div v-if="item.icon" class="icon">
                            <img :src="item.icon" :alt="item.label" />
                        </div>
                        <span> {{ item.label }} </span>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'SideBarShowcase',
    props: {
        menu: {
            type: Array,
            required: true,
        },
        noPrefix: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            sidebarActive: false,
        };
    },
    computed: {
        ...mapState('nav', ['show']),
        homeURL() {
            return this.$helpers.homeURL();
        },
    },
    methods: {
        closeSideBar() {
            this.$store.commit('nav/closeSidebar');
        },
        getPrefix(routeName) {
            return routeName.split('.')[0];
        },
        isActive(routeName) {
            return this.noPrefix
                ? this.$route.name === routeName
                : this.getPrefix(this.$route.name) ===
                      this.getPrefix(routeName);
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'SideBar';
</style>
